enum Partner {
  WYRE = 14,
  TRANSFER_TO = 20,
  TRANGLO = 21,
  INSTAREM = 22,
  VCBR = 23,
  BRI = 24,
  X_CURRENT = 26,
  MONEY_GRAM = 27,
  MONEY_MATCH = 28,
  THUNES = 37,
  LIGHTNET = 52,
  RIPPLE_NET = 53,
  DUTCH_BANGLA = 54,
  NIC = 55,
  TERRAPAY = 56,
  DEEMONEY = 58,
  RAPYD = 61,
  FAYSAL = 62,
  CZCB = 63,
  TRANSWAP = 64,
  BRDGX = 80,
  ANALOGUE_PARTNER = 100,
  CURRENCY_CLOUD_MTO = 68,
  MOOV = 81,
  EMQ = 82,
  REMITEE = 83,
  TENCENT = 84,
  NINE_PAY = 85,
  CONTACT_SYS = 86,
  SMART_SWIFT = 87,
  FINFAN = 88,
  WING = 89,
  NOVATTI = 91,
  ALIPAY = 92,
  BCA = 93,
  DOKU = 98,
  VISA = 102,
  KUMARI = 105,
  BAOKIM = 106,
  FINMO = 104,
  PINGPONG = 108,
  CORPAY = 109,
  PAYME = 94,
  GCASH = 114,
  CURFEX = 115,
  RIPPLE_PAYMENT_DIRECT = 116,
  MDAQ = 117,
  CITIBANK = 118,
  COINS_PH = 11,
  TOPREMIT = 32,
  HANSHAN = 110,
  TAZAPAY = 122,
}
export default Partner
